import { app } from '../game/app';

export const VERSION = '13.3.2-timestep';
export * from './2d';
export * from './core';
export * from './math';
export * from './utils';
export * from './signals';
export * from './ticker';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type InteractionEvent = any;

export interface ITextStyle {
  fill?: string;
  fontSize?: number;
  font?: string;
  align?: string;
}

export type Application = typeof app;
